import { connect } from 'react-redux';
import  { selectors } from '@amplement/backend-connector';

import BasicFavicon from './index';

const mapStateToProps = (state) => {
    const feedNotificationCounter = selectors.feeds._unreadFeeds(state)?.length;
    const isWsOpen = selectors.network.getIsWsOpenSelector(state);
    const isOnline = selectors.network.getIsOnlineSelector(state);
    const isInternetReachable = selectors.network.getIsInternetReachableSelector(state);

    return {
        feedNotificationCounter,
        isOnline: isOnline && isInternetReachable,
        isWsOpen
    };
};

export default connect(mapStateToProps)(BasicFavicon);
